import { useRouter } from "next/router";
import { useQuery } from "@apollo/client";
import { dehydrateApolloClient, initApolloClient } from "@/lib/apolloClient";
import { InitialResolver } from "@/lib/use.middlewares";
import { GET_EJAR_FEES } from "@/graphql/queries/payment";
import PlanCard from "@/components/payment-cards/planCard";
import { Modal } from "@aqar-app/react-ui";
import { WarningAlert } from "@/components/login-alert";
import styles from "@/src/pages/payment-gateway/.module.scss";

function EjarFeesPlans() {
  const router = useRouter();
  const { data } = useQuery(GET_EJAR_FEES, {
    onError: (err) => {
      Modal.open(
        <WarningAlert text={err.message} onOk={() => router.push(`/`)} />,
      )();
    },
  });

  const plans = data?.Offices?.Ejar?.getFees || [];

  return (
    <div className={styles.servicesCards}>
      <h1 className={styles.title}>
        الرجاء اختيار الخدمة التي ترغب بدفع رسومها
      </h1>
      <div className={styles.cardsContainer}>
        {plans?.map((plan, index) => (
          <PlanCard
            plan={{ ...plan, pkgType: plan.type_id, actionTitle: "دفع" }}
            index={index}
          />
        ))}
      </div>
    </div>
  );
}

EjarFeesPlans.getInitialProps = InitialResolver(async () => {
  const apolloClient = initApolloClient();
  await apolloClient.query({ query: GET_EJAR_FEES });
  return dehydrateApolloClient(apolloClient, {});
});

export default EjarFeesPlans;
